import { useEffect, useState } from 'react'
import Button from '../common/Button.js'
import Alert from '../common/Alert.js'
import amountAdjustmentService from '../../services/amountAdjustmentService.js'

const AmountAdjustRequestModal = ({ shipment, onClose, onSaved }) => {
  const [amount, setAmount] = useState('')
  const [remark, setRemark] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    setAmount('')
    setRemark('')
  }, [shipment])

  useEffect(() => {
    if (!shipment) return undefined
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = previous
    }
  }, [shipment])

  if (!shipment) return null

  const save = async () => {
    const value = Number(amount)
    if (!Number.isFinite(value) || value <= 0) {
      Alert.error('Enter the new amount')
      return
    }
    try {
      setSaving(true)
      const response = await amountAdjustmentService.create({
        shipment_id: shipment.shipment_id,
        requested_amount: value,
        remark,
      })
      Alert.success(response.data?.message || 'Request sent')
      onSaved?.(response.data?.data)
      onClose?.()
    } catch (err) {
      Alert.error(err.response?.data?.error || 'Could not send the request')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="fixed inset-0 z-[120] flex items-end sm:items-center justify-center p-2 sm:p-4">
      <div className="absolute inset-0 bg-black/50" onClick={saving ? undefined : onClose} aria-hidden="true" />
      <div className="relative bg-white rounded-xl shadow-xl w-full max-w-md p-4 sm:p-6" role="dialog" aria-modal="true">
        <h2 className="text-lg font-bold text-gray-800">Adjust amount</h2>
        <p className="text-sm text-gray-600 mt-1 break-all">{shipment.shipment_id}</p>
        <p className="text-sm text-gray-600 mt-2">
          Current total ₹{Number(shipment.total_amount || 0).toFixed(2)}. The shipment stays the same until an admin or accountant approves the request.
        </p>
        <label className="block text-sm font-medium text-gray-700 mt-4 mb-1">New amount</label>
        <input
          type="number"
          min="0"
          step="0.01"
          value={amount}
          onChange={(event) => setAmount(event.target.value)}
          onWheel={(event) => event.currentTarget.blur()}
          className="w-full px-3 py-2 border border-gray-300 rounded-xl text-sm [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          placeholder="150"
        />
        <label className="block text-sm font-medium text-gray-700 mt-3 mb-1">Remark</label>
        <textarea
          value={remark}
          onChange={(event) => setRemark(event.target.value)}
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-xl text-sm"
          placeholder="Customer asked to update the amount"
        />
        <div className="mt-4 flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
          <Button variant="secondary" onClick={onClose} disabled={saving}>Cancel</Button>
          <Button variant="primary" onClick={save} loading={saving} disabled={saving}>Raise request</Button>
        </div>
      </div>
    </div>
  )
}

export default AmountAdjustRequestModal
